var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","id":"text-wrapper"}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('h5',[_vm._v(_vm._s(_vm.infoTournament.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mt-2":""}},[_c('div')])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76331022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/partnering/Tournament.vue
// module id = T+ax
// module chunks = 2